import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { ZDialogComponent } from '../z-dialog/z-dialog.component';
import { ZInputComponent } from '../z-input/z-input.component';
import { ZButtonComponent } from '../z-button/z-button.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-reprove-dialog',
    templateUrl: './reprove-dialog.component.html',
    styleUrl: './reprove-dialog.component.scss',
    imports: [ZDialogComponent, ZInputComponent, ZButtonComponent, MatDialogClose, TranslatePipe]
})

export class ReproveDialog {
  observacoes: FormControl<string> = new FormControl();

  constructor(
    public dialogRef: MatDialogRef<ReproveDialog>,
    @Inject(MAT_DIALOG_DATA) public name: string
  ) {}

  send(): void {
    this.dialogRef.close(this.observacoes);
  }
}
